import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { mappingResultError, Result, UseCase, UniqueEntityID } from '@digibricks/domains';
import { Heading, Headings, NoneValue, Questions } from '../../../domain';
export var CREATE_HEADING_USE_CASE = 'CREATE_HEADING_USE_CASE';
export var CreateHeadingUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(CreateHeadingUseCase, _UseCase);

  var _super = _createSuper(CreateHeadingUseCase);

  function CreateHeadingUseCase() {
    _classCallCheck(this, CreateHeadingUseCase);

    return _super.call(this);
  }

  _createClass(CreateHeadingUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var data, id, previousHeadingId, sectionId, previousQuestionId, nextHeadingId, nextQuestionId, formId, title, description, headingOrError, newHeadings, heading, resolvedNextHeadingId, existingHead, previousHeading, nextHeading;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = input.data;
                id = data.id, previousHeadingId = data.previousHeadingId, sectionId = data.sectionId, previousQuestionId = data.previousQuestionId, nextHeadingId = data.nextHeadingId, nextQuestionId = data.nextQuestionId, formId = data.formId, title = data.title, description = data.description;
                headingOrError = Heading.create({
                  title: title,
                  description: description,
                  sectionId: sectionId,
                  previousHeadingId: previousHeadingId,
                  previousQuestionId: previousQuestionId,
                  nextQuestionId: nextQuestionId,
                  nextHeadingId: nextHeadingId,
                  formId: formId
                }, id);
                newHeadings = _toConsumableArray(input.headings);

                if (!headingOrError.isFailure) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", mappingResultError(headingOrError));

              case 6:
                heading = headingOrError.getValue(); // When inserting as the new head of the section, always re-link the previous head.
                // Callers sometimes omit nextHeadingId (e.g. section-selected create), which would
                // leave two headings with previousHeadingId=none and Headings.sort would drop one.

                resolvedNextHeadingId = nextHeadingId;

                if (previousHeadingId === NoneValue && resolvedNextHeadingId === NoneValue) {
                  existingHead = input.headings.find(function (h) {
                    return h.sectionId === sectionId && h.previousHeadingId === NoneValue && h.id.toString() !== heading.id.toString();
                  });

                  if (existingHead) {
                    resolvedNextHeadingId = existingHead.id.toString();
                  }
                }

                if (previousHeadingId !== NoneValue) {
                  previousHeading = input.headings.find(function (h) {
                    return h.id.toString() === previousHeadingId;
                  });
                  newHeadings = newHeadings.filter(function (h) {
                    return h.id.toString() !== previousHeadingId;
                  });

                  if (previousHeading) {
                    previousHeading.updateNextHeadingId(heading.id.toString());

                    if (previousHeading.nextQuestionId === heading.nextQuestionId) {
                      previousHeading.updateNextQuestionId(NoneValue);
                    }

                    newHeadings.push(previousHeading);
                  }
                }

                if (resolvedNextHeadingId !== NoneValue) {
                  nextHeading = input.headings.find(function (h) {
                    return h.id.toString() === resolvedNextHeadingId;
                  });
                  newHeadings = newHeadings.filter(function (h) {
                    return h.id.toString() !== resolvedNextHeadingId;
                  });

                  if (nextHeading) {
                    nextHeading.updatePreviousHeadingId(heading.id.toString());

                    if (nextHeading.previousQuestionId === heading.previousQuestionId) {
                      nextHeading.updatePreviousQuestionId(NoneValue);
                    }

                    heading.updateNextHeadingId(resolvedNextHeadingId);
                    newHeadings.push(nextHeading);
                  }
                }

                newHeadings.push(heading);
                return _context.abrupt("return", Result.ok({
                  newHeadings: newHeadings,
                  newHeading: heading
                }));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return CreateHeadingUseCase;
}(UseCase);
export var generateCreateHeadingInputUseCase = function generateCreateHeadingInputUseCase(_ref) {
  var sections = _ref.sections,
      questions = _ref.questions,
      headings = _ref.headings,
      selectedFormItemId = _ref.selectedFormItemId,
      defaultTitle = _ref.defaultTitle,
      defaultDescription = _ref.defaultDescription,
      formId = _ref.formId;
  var foundSection = sections.find(function (s) {
    return s.id.toString() === selectedFormItemId;
  });

  if (foundSection) {
    var _filterHeadings = headings.filter(function (h) {
      return h.sectionId === foundSection.id.toString();
    });

    var _filterQuestions = questions.filter(function (q) {
      return q.sectionId === foundSection.id.toString();
    });

    var _questionsWithHeadings = Headings.sortWithQuestions(Headings.sort(_filterHeadings), _filterQuestions);

    var _nextFormItem = _questionsWithHeadings.length === 0 ? null : _questionsWithHeadings[0];

    var nextHeading = _nextFormItem ? _nextFormItem.type === 'heading' ? _nextFormItem : Headings.findNearestNextHeadingWithItemId(_nextFormItem.id.toString(), _filterQuestions, _filterHeadings, false) : null;
    return {
      id: new UniqueEntityID().toString(),
      formId: formId,
      title: defaultTitle,
      description: defaultDescription,
      sectionId: foundSection.id.toString(),
      previousHeadingId: NoneValue,
      previousQuestionId: NoneValue,
      nextQuestionId: !_nextFormItem ? NoneValue : _nextFormItem.type !== 'heading' ? _nextFormItem.id.toString() : NoneValue,
      nextHeadingId: nextHeading ? nextHeading.id.toString() : NoneValue
    };
  }

  var foundFormItem;
  foundFormItem = headings.find(function (h) {
    return h.id.toString() === selectedFormItemId;
  });

  if (!foundFormItem) {
    foundFormItem = questions.find(function (q) {
      return q.id.toString() === selectedFormItemId;
    });
  }

  var filterHeadings = Headings.sort(headings.filter(function (h) {
    return h.sectionId === foundFormItem.sectionId;
  }));
  var filterQuestions = Questions.sortQuestions(questions.filter(function (q) {
    return q.sectionId === foundFormItem.sectionId;
  }));
  var questionsWithHeadings = Headings.sortWithQuestions(filterHeadings, filterQuestions);

  for (var i = 0; i < questionsWithHeadings.length; i++) {
    var formItem = questionsWithHeadings[i];

    if (formItem.id.toString() === selectedFormItemId) {
      foundFormItem = formItem;
      break;
    }
  }

  var filterQuestionsWithHeadings = questionsWithHeadings.filter(function (item) {
    return item.sectionId === foundFormItem.sectionId;
  });
  var formItemIndex = filterQuestionsWithHeadings.findIndex(function (i) {
    return i.id.toString() === foundFormItem.id.toString();
  });
  var nextFormItem = formItemIndex === filterQuestionsWithHeadings.length - 1 ? null : filterQuestionsWithHeadings[formItemIndex + 1];

  if (foundFormItem.type === 'heading') {
    var _nextHeading = Headings.findNearestNextHeadingWithItemId(foundFormItem.id.toString(), filterQuestions, filterHeadings, true);

    return {
      id: new UniqueEntityID().toString(),
      title: defaultTitle,
      description: defaultDescription,
      sectionId: foundFormItem.sectionId,
      previousHeadingId: foundFormItem.id.toString(),
      previousQuestionId: NoneValue,
      nextQuestionId: !nextFormItem ? NoneValue : nextFormItem.type !== 'heading' ? nextFormItem.id.toString() : NoneValue,
      nextHeadingId: _nextHeading ? _nextHeading.id.toString() : NoneValue,
      formId: formId.toString()
    };
  } else {
    var previousHeading = Headings.findNearestPreviousHeadingWithItemId(selectedFormItemId, filterQuestions, filterHeadings, false);

    var _nextHeading2 = Headings.findNearestNextHeadingWithItemId(selectedFormItemId, filterQuestions, filterHeadings, false);

    return {
      id: new UniqueEntityID().toString(),
      formId: formId,
      title: defaultTitle,
      description: defaultDescription,
      sectionId: foundFormItem.sectionId,
      previousHeadingId: previousHeading ? previousHeading.id.toString() : NoneValue,
      previousQuestionId: foundFormItem.id.toString(),
      nextQuestionId: !nextFormItem ? NoneValue : nextFormItem.type !== 'heading' ? nextFormItem.id.toString() : NoneValue,
      nextHeadingId: _nextHeading2 ? _nextHeading2.id.toString() : NoneValue
    };
  }
};